import React from 'react';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { connect } from 'react-redux';
import GoogleInfoBox from './GoogleInfoBox';
import moment from 'moment';
import {convertMiPerHourToKmPerHour} from 'services/systemOfUnitsServices';

import mapPin from 'Content/Assets/images/maps/map-marker_100.png';
import noCrashPin from 'Content/Assets/images/maps/black_48.png';
import heavyPin from 'Content/Assets/images/maps/heavy_48.png';
import lightPin from 'Content/Assets/images/maps/light_48.png';
import veryHeavyPin from 'Content/Assets/images/maps/veryHeavy_48.png';
import veryLightPin from 'Content/Assets/images/maps/veryLight_48.png';
import moderatePin from 'Content/Assets/images/maps/moderate_48.png';

const { Marker, InfoWindow } = require("react-google-maps");

class GoogleMarker extends React.Component {
    constructor(props){
        super(props);

        this.onToggleOpenMainInfoWindow = this.onToggleOpenMainInfoWindow.bind(this);

        this.state = {
            isOpenMainInfoWindow: false
        };
    }

    /**
     * gestisce la chiusura o apertura dell'info windows del pin
    */
   onToggleOpenMainInfoWindow(){
        this.setState({
            isOpenMainInfoWindow: !this.state.isOpenMainInfoWindow
        });
    }

    render() {
        const {translate, currentLanguage, icn, icnPlus, isMilesPerHour, pdof, withIcnLink} = this.props;

        var position = { lat: icn.latitude, lng: icn.longitude };
        var addres = icn.address;
        var momentutc = moment.utc(icn.crashDate);
        momentutc.locale(currentLanguage);

        var dateTime = "UTC " + momentutc.format("L") + " " + momentutc.format("LT");

        var speed = icn.speed;
        var unitOfMeaserLabel = translate('GLOBAL.miph');

        if(!isMilesPerHour)
        {
            speed = parseFloat(convertMiPerHourToKmPerHour(icn.speed));
            unitOfMeaserLabel = translate('GLOBAL.kmph');
        }

        var {isOpenMainInfoWindow} = this.state;

        var pin = mapPin;

        if(icn.severityCode === "NonCrash")
        {
            pin = noCrashPin;
        }
        if(icn.severityCode === "VeryLight")
        {
            pin = veryLightPin;
        }
        else if(icn.severityCode === "VeryHeavy")
        {
            pin = veryHeavyPin;
        }
        else if(icn.severityCode === "Light")
        {
            pin = lightPin;
        }
        else if(icn.severityCode === "Moderate")
        {
            pin = moderatePin;
        }
        else if(icn.severityCode === "Heavy")
        {
            pin = heavyPin;
        }

        return (
            <Marker
                key={icn.id}
                icon={pin}
                position={{ lat: icn.latitude, lng: icn.longitude }}
                onClick={this.onToggleOpenMainInfoWindow}
                >
                {isOpenMainInfoWindow &&
                    <InfoWindow onCloseClick={this.onToggleOpenMainInfoWindow}>
                        <GoogleInfoBox translate={translate} dateTime={dateTime} position={position}
                            icnPlus={icnPlus} addres={addres} isMilesPerHour={isMilesPerHour}
                            preCrashSpeed={speed} unitOfMeaserLabel={unitOfMeaserLabel} pdof={pdof} withIcnLink={withIcnLink}
                            severity={icn.severityCode} icnId={icn.id} closeCallBack={this.onToggleOpenMainInfoWindow} />
                    </InfoWindow>
                }
            </Marker>
        );
    }
}

GoogleMarker.propTypes = {
    //x: PropTypes.object,
    //x: PropTypes.func,
    //x: PropTypes.bool,
    //x: PropTypes.array.isRequired,
    //x: PropTypes.object.isRequired
}

function mapStateToProps(state, ownProps){
    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code
    }
}
export default connect(mapStateToProps, null)(GoogleMarker);


// WEBPACK FOOTER //
// ./src/components/maps/GoogleMarker.js